import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_PROCESS_STEPS_UPDATE_SUBSCRIPTION = graphql(/* GraphQL */ `
  subscription NegotiationCaseProcessStepsUpdate {
    tesseract {
      negotiationCaseProcessStepsUpdate {
        id
      }
    }
  }
`);
